<script>
  // # # # # # # # # # # # # #
  //
  //  Image popup module
  //
  // # # # # # # # # # # # # #

  // *** IMPORT
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import imagesLoaded from "imagesloaded";
  import { createEventDispatcher } from "svelte";
  import MediaQuery from "svelte-media-query";

  // *** COMPONENTS
  import Taglist from "./Taglist.svelte";

  // *** PROPS
  export let item;

  // *** DOM REFERENCES
  let popUpEl;
  let videoEl;

  // *** CONSTANTS
  const VIDEO_ROOT = "https://res.cloudinary.com/pwr/video/upload/";
  const REMOTE_FOLDER = "completeworks";

  // *** VARIABLES
  let videoUrl = "";
  let posterImageSrc = "";
  let loaded = false;
  let paused = true;
  let autoplay = false;

  const toggleVideo = () => (paused ? videoEl.play() : videoEl.pause());
  const dispatch = createEventDispatcher();
  const closePopUp = () => dispatch("close");

  // *** ON MOUNT
  onMount(async () => {
    if (item.header.video) {
      videoUrl = item.header.video.url.replace("https://completeworks.ch", "");
      posterImageSrc =
        VIDEO_ROOT +
        REMOTE_FOLDER +
        encodeURI(videoUrl.substring(0, videoUrl.length - 4) + ".jpg");

      videoEl.addEventListener(
        "loadeddata",
        function() {
          loaded = true;
        },
        false
      );
    } else {
      imagesLoaded(popUpEl, instance => {
        loaded = true;
      });
    }
  });
</script>

<style lang="scss">
  @import "../_variables.scss";

  .popup {
    $block: &;
    background: white;

    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;

    &__inner {
      width: 100vw;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      video {
        max-width: 95vw;
        height: 90vh;
        opacity: 0;
        transition: opacity $slow-easing;
        pointer-events: none;

        &.loaded {
          opacity: 1;
        }
      }

      img {
        width: 95%;
        height: calc(95% - 25px);
        object-fit: contain;
        opacity: 0;
        transition: opacity $slow-easing;

        &.loaded {
          opacity: 1;
        }
      }
    }
  }

  .close {
    position: fixed;
    top: 10px;
    right: 20px;
    z-index: 3000;
    height: 50px;
    width: 50px;
    opacity: 1;

    @include screen-size("small") {
      height: 40px;
      width: 40px;
    }

    cursor: pointer;
    transition: transform $fast-easing;

    &:hover {
      transform: scale(1.1);
    }
  }
  .cross {
    height: 100%;
    line {
      stroke: $black;
      stroke-width: 2px;
    }
  }

  .tags {
    margin-top: 15px;
    max-width: 90vw;
  }

  .video-play {
    position: absolute;
    top: 50%;
    z-index: 1000;
    height: 200px;
    width: 200px;
    left: 50%;
    margin-left: -100px;
    margin-top: -100px;
    color: white;
    opacity: 0.6;
    pointer-events: none;
    transition: opacity 0.3s ease-out;
    pointer-events: none;
  }

  .play-layer {
    opacity: 1;
    cursor: pointer;
  }
</style>

<div class="popup image" bind:this={popUpEl}>
  <div class="popup__inner">
    {#if item.header.video}
      <span class="play-layer" on:click={toggleVideo}>
        <video
          class:loaded
          src={item.header.video.url}
          bind:this={videoEl}
          poster={posterImageSrc}
          bind:paused />
      </span>
      {#if paused}
        <svg
          in:fade
          class="video-play"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="0.2">
          <circle cx="12" cy="12" r="10" />
          <polygon points="10 8 16 12 10 16 10 8" />
        </svg>
      {/if}
    {:else}
      <img
        class:loaded
        srcset="{item.header.featured_image.sizes.small.url}
        {item.header.featured_image.sizes.small.width}w, {item.header.featured_image.sizes.medium.url}
        {item.header.featured_image.sizes.medium.width}w, {item.header.featured_image.sizes.large.url}
        {item.header.featured_image.sizes.large.width}w"
        sizes="100vw"
        src={item.header.featured_image.sizes.large.url}
        alt={item.header.title} />
    {/if}

    <MediaQuery query="(min-width: 800px)" let:matches>
      {#if matches}
        <div class="tags">
          <Taglist {item} />
        </div>
      {/if}
    </MediaQuery>

  </div>

  <!-- {# NAVIGATION: CLOSE #} -->
  <div class="close" on:click={closePopUp}>
    <svg class="cross" viewBox="0 0 44 44">
      <line x1="0.71" y1="0.71" x2="43.29" y2="43.29" />
      <line x1="0.71" y1="43.29" x2="43.29" y2="0.71" />
    </svg>
  </div>
</div>
